import axios from '@axios';
// import HelperService from './HelperService';

// const helperService = new HelperService();
const base = '/api/v1/prisons';
const basePrisonUsers = '/api/v1/prison-users';

export default {
  getPrisonInfo(prisonId) {
    return axios.get(`${base}/single-prison/${prisonId}`);
  },
  getPrison() {
    return axios.get(`${base}/prison`);
  },
  getFundTokens() {
    return axios.get(`${base}/prison/fund-tokens/remaining`);
  },
  getOTP(visitId) {
    return axios.get(`${basePrisonUsers}/otp/recording-and-audit-trail/${visitId}`);
  },
};
